import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { handleSendGlobal, handleSendSetup } from "../../helpers";
import { updateGlobalValue } from "../../store/entities/global";
import { updateSetup } from "../../store/entities/setup";
import Global from "./globalIndicator";

function OptionsInput(props) {
  const dispatch = useDispatch();
  const {
    title,
    field,
    value,
    multiple,
    characters = 2,
    global,
    classNames = "",
  } = props;

  const className = "field value " + classNames;

  const { selectedProjectId } = useSelector((state) => state.user);

  function handleChange(e) {
    let value = e.target.value;
    if (e.target.value) {
      value = value.slice(-characters);
    } else value = 0;
    value = parseInt(value);
    global
      ? dispatch(updateGlobalValue({ key: field, value }))
      : dispatch(
          updateSetup({ key: field, value, projectId: selectedProjectId })
        );
  }

  function sendChanges() {
    global ? handleSendGlobal() : handleSendSetup();
  }

  const row = (
    <div className="row">
      {global ? <Global /> : null}
      <p className="field display description">{title}</p>
      <input
        type="text"
        id={field}
        name={field}
        value={value}
        // onKeyDown={isNumberKey}
        onChange={handleChange}
        onBlur={sendChanges}
        className={className}
      />
    </div>
  );

  const input = (
    <input
      type="text"
      id={field}
      name={field}
      value={value}
      // onKeyDown={isNumberKey}
      onChange={handleChange}
      onBlur={sendChanges}
      className={className}
    />
  );

  if (multiple) return input;
  else return row;
}
export default OptionsInput;
